import React from "react";
import { motion } from "framer-motion";
import { FaHandshake, FaGraduationCap, FaRocket, FaEye, FaUsers, FaAward } from "react-icons/fa";
import { Link } from "react-router-dom";

const About = () => {

   const handleScroll = () => {
    window.scrollTo({ top: 0, behavior: 'smooth'});
  };
  const teamMembers = [
    {
      name: "DEMO USER",
      role: "DEMO ROLE",
      qualifications: "MBA in Finance, NISM Certified, 15+ years in wealth management",
      passion: "I am driven by the 'lightbulb moment'—that instant when a complex concept clicks for a client and they feel a new sense of power over their financial future.",
      img: "https://randomuser.me/api/portraits/men/46.jpg",
    },
    {
      name: "DEMO USER 2",
      role: "DEMO ROLE 2",
      qualifications: "AMFI Registered, Certified Financial Planner, expert in retirement planning",
      passion: "For me, it's about building lasting relationships. There's no greater reward than helping a family craft a plan that secures their children's education and their own peaceful retirement.",
      img: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      name: "DEMO USER 3",
      role: "DEMO ROLE 3",
      qualifications: "NISM Series X-A Certified, 12+ years in portfolio management",
      passion: "I believe everyone deserves access to sound financial advice, regardless of their investment size or background.",
      img: "https://randomuser.me/api/portraits/men/51.jpg",
    }
  ];

  const values = [
    {
      title: "Integrity",
      desc: "We operate with unwavering honesty and ethics. Your trust is our most valuable asset.",
      icon: <FaHandshake className="text-3xl text-[#02ca02]" />
    },
    {
      title: "Education First",
      desc: "We empower you with knowledge before encouraging action. We ensure you understand the 'why' behind every strategy.",
      icon: <FaGraduationCap className="text-3xl text-[#02ca02]" />
    },
    {
      title: "Empowerment",
      desc: "We don't just give advice; we give you control. We equip you with skills to navigate the financial landscape independently.",
      icon: <FaRocket className="text-3xl text-[#02ca02]" />
    },
    {
      title: "Transparency",
      desc: "We believe in clear, open communication. No confusing jargon or surprise fees.",
      icon: <FaEye className="text-3xl text-[#02ca02]" />
    }
  ];

  const certifications = [
    {
      name: "AMFI Registered",
      details: "Our advisors are AMFI registered Mutual Fund Distributors. This ensures all advice and transactions are compliant and ethical.",
      logo: "AMFI"
    },
    {
      name: "NISM Certified",
      details: "Our team holds relevant NISM certifications mandated by SEBI to ensure the highest standards of knowledge and professionalism.",
      logo: "NISM"
    }
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#02ca02] to-[#02a102] text-white py-20">
        <div className="container mx-auto text-center px-6">
          <motion.h1 
            className="text-4xl md:text-6xl font-bold mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            About Karikar EduWealth
          </motion.h1>
          <motion.p 
            className="text-lg md:text-xl max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            Building Financial Futures, Together. We believe that financial literacy is not a privilege, but a fundamental right.
          </motion.p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <motion.h2 
            className="text-3xl font-bold mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Our Mission & Vision
          </motion.h2>
          <div className="grid md:grid-cols-2 gap-10 max-w-4xl mx-auto">
            <motion.div 
              className="bg-white shadow-md rounded-xl p-8 hover:shadow-lg transition border-t-4 border-[#02ca02]"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <h3 className="text-2xl font-semibold mb-4 text-[#02ca02]">Our Mission</h3>
              <p className="text-gray-600">
                To bridge the gap between financial potential and financial reality. We provide the knowledge, tools, and personalized support you need to build a secure and prosperous future.
              </p>
            </motion.div>
            <motion.div 
              className="bg-white shadow-md rounded-xl p-8 hover:shadow-lg transition border-t-4 border-[#fe0000]"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h3 className="text-2xl font-semibold mb-4 text-[#fe0000]">Our Vision</h3>
              <p className="text-gray-600">
                To create a world where everyone is equipped with the education and confidence to take control of their financial destiny.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <motion.h2 
            className="text-3xl font-bold mb-6 text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Our Story: The Inspiration Behind It All
          </motion.h2>
          <motion.div 
            className="max-w-3xl mx-auto bg-white p-8 rounded-xl shadow-md"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <p className="text-gray-600 leading-relaxed mb-6">
              Karikar EduWealth was founded on a simple, powerful observation: the world of finance can often feel complex, intimidating, and exclusive. Our founders saw a growing need for a guide—a trusted ally to demystify investments, simplify planning, and empower individuals to make decisions with clarity and confidence.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We reject the one-size-fits-all mentality. Your financial journey is unique, and our approach reflects that. We begin with a deep-dive conversation to understand your goals, risk appetite, and life situation. We then craft a tailored roadmap designed specifically to help you win.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <motion.h2 
            className="text-3xl font-bold mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Our Values: The Principles That Guide Us
          </motion.h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
            {values.map((value, idx) => (
              <motion.div
                key={idx}
                className="bg-white shadow-md rounded-xl p-6 hover:shadow-lg transition border-t-4 border-[#02ca02]"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
              >
                <div className="flex justify-center mb-4">
                  {value.icon}
                </div>
                <h3 className="text-xl font-semibold mb-2">{value.title}</h3>
                <p className="text-gray-600 text-sm">{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16">
        <div className="container mx-auto px-6 text-center">
          <motion.h2 
            className="text-3xl font-bold mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Meet the Team: The Faces Behind the Mission
          </motion.h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-12">
            We're not just a company; we're a team of passionate, certified professionals dedicated to your success.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                className="bg-white shadow-md rounded-xl p-6 hover:shadow-lg transition"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-32 h-32 mx-auto rounded-full mb-4 object-cover border-4 border-[#02ca02]"
                />
                <h3 className="text-xl font-semibold">{member.name}</h3>
                <p className="text-[#02ca02] font-medium mb-2">{member.role}</p>
                <p className="text-gray-500 text-sm mb-3">{member.qualifications}</p>
                <p className="text-gray-600 text-sm italic">"{member.passion}"</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Credentials & Associations */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <motion.h2 
            className="text-3xl font-bold mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Our Credentials & Associations
          </motion.h2>
          <motion.p 
            className="text-gray-600 max-w-2xl mx-auto mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Your trust is earned through demonstrated expertise and a commitment to regulatory excellence.
          </motion.p>
          
          <div className="grid md:grid-cols-2 gap-10 max-w-4xl mx-auto">
            {certifications.map((cert, idx) => (
              <motion.div
                key={idx}
                className="bg-white shadow-md rounded-xl p-8 hover:shadow-lg transition border-t-4 border-[#02ca02]"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
              >
                <div className="w-16 h-16 bg-[#02ca02] bg-opacity-20 rounded-full flex items-center justify-center text-[#02ca02] mx-auto mb-4">
                  <FaAward className="text-2xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">{cert.name}</h3>
                <p className="text-gray-600 text-sm">{cert.details}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="py-16">
        <div className="container mx-auto px-6 text-center">
          <motion.h2 
            className="text-3xl font-bold mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Our Approach: How We Achieve Results for You
          </motion.h2>
          <div className="grid md:grid-cols-2 gap-10 max-w-4xl mx-auto">
            <motion.div 
              className="bg-white shadow-md rounded-xl p-8 hover:shadow-lg transition border-t-4 border-[#02ca02]"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <div className="w-16 h-16 bg-[#02ca02] bg-opacity-20 rounded-full flex items-center justify-center text-[#02ca02] mx-auto mb-4">
                <FaGraduationCap className="text-2xl" />
              </div>
              <h3 className="text-xl font-semibold mb-4">Practical Learning</h3>
              <p className="text-gray-600">
                We move beyond theory. Our workshops and consultations are filled with real-world examples, interactive scenarios, and actionable steps you can implement immediately.
              </p>
            </motion.div>
            <motion.div 
              className="bg-white shadow-md rounded-xl p-8 hover:shadow-lg transition border-t-4 border-[#fe0000]"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="w-16 h-16 bg-[#fe0000] bg-opacity-20 rounded-full flex items-center justify-center text-[#fe0000] mx-auto mb-4">
                <FaUsers className="text-2xl" />
              </div>
              <h3 className="text-xl font-semibold mb-4">Personalized Strategies</h3>
              <p className="text-gray-600">
                Your financial plan should be as unique as you are. We craft tailored roadmaps designed specifically to help you achieve your financial goals.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-gradient-to-r from-[#02ca02] to-[#02a102] text-white py-16 text-center">
        <motion.h2 
          className="text-3xl md:text-4xl font-bold mb-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Ready to Start Your Journey to Financial Empowerment?
        </motion.h2>
        <Link to='/contact' onClick={handleScroll}>
        <motion.button 
          className="bg-white text-[#02ca02] px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition shadow-md"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Get in Touch with Our Certified Experts
        </motion.button>
        </Link>
      </section>
    </div>
  );
};

export default About;